import React from 'react';

const EmptyApplication = ({ selectedTab }) => {
  const isSaved = selectedTab === 'saved';

  return (
    <div className='flex flex-col justify-center items-center w-full p-10 h-[300px] tabletH:h-[380px]'>
      <div className='pb-[60px] tabletH:pb-6 w-[570px] flex items-center justify-center text-text-placeholder'>
        {isSaved ? 'No saved jobs yet' : 'No applications yet'}
      </div>
    </div>
  );
};

export default EmptyApplication;
